<div class="auth-container">
  <div class="auth-background">
    <div class="background-pattern"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <div class="auth-header">
        <div class="app-logo">
          <img
            class="logo-img"
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
          />
          <h1 class="app-title">ReBall</h1>
        </div>
        <h2 class="auth-title">Create Account</h2>
        <p class="auth-subtitle">Join the padel community today</p>
      </div>

      <form
        [formGroup]="registerForm"
        (ngSubmit)="onRegister()"
        class="auth-form"
      >
        <div class="form-row">
          <div class="form-group">
            <label class="form-label" for="firstName">First Name</label>
            <div class="input-wrapper">
              <input
                type="text"
                id="firstName"
                formControlName="firstName"
                class="form-input"
                [class.error]="submitted && f?.['firstName']?.errors"
                placeholder="Enter first name"
              />
              <div class="input-icon">
                <lucide-icon name="user" [size]="18"></lucide-icon>
              </div>
            </div>
            <div
              *ngIf="submitted && f?.['firstName']?.errors"
              class="error-message"
            >
              <div *ngIf="f?.['firstName']?.errors?.['required']">
                First name is required
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="lastName">Last Name</label>
            <div class="input-wrapper">
              <input
                type="text"
                id="lastName"
                formControlName="lastName"
                class="form-input"
                [class.error]="submitted && f?.['lastName']?.errors"
                placeholder="Enter last name"
              />
              <div class="input-icon">
                <lucide-icon name="user" [size]="18"></lucide-icon>
              </div>
            </div>
            <div
              *ngIf="submitted && f?.['lastName']?.errors"
              class="error-message"
            >
              <div *ngIf="f?.['lastName']?.errors?.['required']">
                Last name is required
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="email">Email</label>
          <div class="input-wrapper">
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-input"
              [class.error]="submitted && f?.['email']?.errors"
              placeholder="Enter your email"
            />
            <div class="input-icon">
              <lucide-icon name="mail" [size]="18"></lucide-icon>
            </div>
          </div>
          <div *ngIf="submitted && f?.['email']?.errors" class="error-message">
            <div *ngIf="f?.['email']?.errors?.['required']">
              Email is required
            </div>
            <div *ngIf="f?.['email']?.errors?.['email']">
              Invalid email format
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="phoneNumber">Phone Number</label>
          <div class="input-wrapper">
            <input
              type="text"
              id="phoneNumber"
              formControlName="phoneNumber"
              class="form-input"
              [class.error]="submitted && f?.['phoneNumber']?.errors"
              placeholder="Enter phone number"
            />
            <div class="input-icon">
              <lucide-icon name="phone" [size]="18"></lucide-icon>
            </div>
          </div>
          <div
            *ngIf="submitted && f?.['phoneNumber']?.errors"
            class="error-message"
          >
            <div *ngIf="f?.['phoneNumber']?.errors?.['required']">
              Phone number is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="username">Username</label>
          <div class="input-wrapper">
            <input
              type="text"
              id="username"
              formControlName="username"
              class="form-input"
              [class.error]="(submitted && f?.['username']?.errors) || usernameAvailable === false"
              [class.success]="usernameAvailable === true"
              placeholder="Choose a username"
              (blur)="onUsernameBlur()"
            />
            <div
              class="input-icon"
              *ngIf="!checkingUsername && usernameAvailable === null"
            >
              &#64;
            </div>
            <div class="input-icon checking" *ngIf="checkingUsername">
              <lucide-icon name="loader-2" [size]="16"></lucide-icon>
            </div>
            <div
              class="input-icon available"
              *ngIf="!checkingUsername && usernameAvailable === true"
            >
              ✓
            </div>
            <div
              class="input-icon taken"
              *ngIf="!checkingUsername && usernameAvailable === false"
            >
              ✗
            </div>
          </div>
          <div
            *ngIf="submitted && f?.['username']?.errors"
            class="error-message"
          >
            <div *ngIf="f?.['username']?.errors?.['required']">
              Username is required
            </div>
            <div *ngIf="f?.['username']?.errors?.['noSpaces']">
              Username cannot contain spaces
            </div>
          </div>
          <div
            *ngIf="usernameAvailable === false && !f?.['username']?.errors?.['noSpaces']"
            class="error-message"
          >
            This username is already taken
          </div>
          <div *ngIf="usernameAvailable === true" class="success-message">
            Username is available
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="password">Password</label>
          <div class="input-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              class="form-input"
              [class.error]="submitted && f?.['password']?.errors"
              placeholder="Create a password"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
            >
              <lucide-icon
                [name]="showPassword ? 'eye-off' : 'eye'"
                [size]="18"
              ></lucide-icon>
            </button>
          </div>
          <div
            *ngIf="submitted && f?.['password']?.errors?.['required']"
            class="error-message"
          >
            Password is required
          </div>
          <div
            class="password-requirements"
            *ngIf="f?.['password']?.value || submitted"
          >
            <div class="requirements-title">Password must contain:</div>
            <div class="requirements-list">
              <div
                class="requirement-item"
                [class.valid]="hasMinLength"
                [class.invalid]="!hasMinLength && submitted"
              >
                <span class="check-icon">{{ hasMinLength ? "✓" : "○" }}</span>
                <span>At least 8 characters</span>
              </div>
              <div
                class="requirement-item"
                [class.valid]="hasUpperCase"
                [class.invalid]="!hasUpperCase && submitted"
              >
                <span class="check-icon">{{ hasUpperCase ? "✓" : "○" }}</span>
                <span>One uppercase letter (A-Z)</span>
              </div>
              <div
                class="requirement-item"
                [class.valid]="hasNumber"
                [class.invalid]="!hasNumber && submitted"
              >
                <span class="check-icon">{{ hasNumber ? "✓" : "○" }}</span>
                <span>One number (0-9)</span>
              </div>
              <div
                class="requirement-item"
                [class.valid]="hasSymbol"
                [class.invalid]="!hasSymbol && submitted"
              >
                <span class="check-icon">{{ hasSymbol ? "✓" : "○" }}</span>
                <span>One symbol (!&#64;#$%^&*)</span>
              </div>
            </div>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="loading"
          class="auth-button primary"
          [class.loading]="loading"
        >
          <div class="button-content">
            <div class="button-spinner" *ngIf="loading"></div>
            <span class="button-text">{{
              loading ? "Creating Account..." : "Create Account"
            }}</span>
          </div>
        </button>

        <div class="auth-divider">
          <span>Already have an account?</span>
        </div>

        <button type="button" routerLink="/login" class="auth-button secondary">
          Sign In
        </button>
      </form>
    </div>
  </div>
</div>
